import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Zastosowano kod promocyjny {{code}}',
  [COUPON_TYPES.CASHBACK]: 'Zastosowano punkty lojalnościowe',
  [COUPON_TYPES.REWARD]: 'Zastosowano nagrodę',
  [COUPON_TYPES.GIFT_CARD]: 'Zastosowano kartę podarunkową',
};

export default Coupons;
